import React from "react";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import IconComponent from "@CubeComponents/icons";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { fileViewIconsMapper, fileViewOptions } from "./constants";
import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";
import Text from "@CubeComponents/html/Text/Text";
import useFileManagerToolbar from "./useFileManagerToolbar";

interface ToolbarProps {
  toolbarClick: Function;
  toolbarItems: any;
  allowViewFileOptions: boolean;
  filesViewMode: string;
  setFilesViewMode: Function;
}

const Toolbar = ({
  toolbarClick = () => {},
  toolbarItems = [],
  allowViewFileOptions,
  filesViewMode,
  setFilesViewMode,
}: ToolbarProps) => {
  const { handleToolBtnClick, handleOptionsViewClick } = useFileManagerToolbar({
    toolbarClick,
    setFilesViewMode,
  });

  return (
    <div className="flex gap-5 border overflow-auto border-none border-b-button_light w-full p-4">
      <div className="flex justify-between w-full items-center">
        <div className="flex gap-5 items-center">
          {toolbarItems.map((item: any, index: number) => {
            const shouldRender = (item.align === "left" || !item.align) && item.show;
            if (!shouldRender) return null;
            if (item.template) return <React.Fragment key={item.id || `left-${index}`}>{item.template}</React.Fragment>;
            return (
              <ButtonComponent
                id={item.id}
                onClick={(e: React.MouseEvent) => handleToolBtnClick(e, item.id)}
                key={item.id}
                buttonType={BUTTON_TYPES.TEXT_BUTTON}
                data-testid={item["data-testid"]}
              >
                <div className="flex items-center gap-2">
                  <IconComponent name={item.iconName} width="1.5rem" height="1.5rem" />
                  <Text>{item.text}</Text>
                </div>
              </ButtonComponent>
            );
          })}
        </div>
        <div className="flex gap-5 items-center">
          {toolbarItems.map(
            (item: any, index: number) =>
              item.align == "right" &&
              item.show &&
              (item.template ? (
                <React.Fragment key={item.id || `right-${index}`}>{item.template}</React.Fragment>
              ) : (
                <ButtonComponent
                  id={item.id}
                  onClick={(e: React.MouseEvent) => handleToolBtnClick(e, item.id)}
                  key={item.id}
                  buttonType={BUTTON_TYPES.TEXT_BUTTON}
                >
                  <div className="flex items-center gap-2">
                    <IconComponent name={item.iconName} width="1.5rem" height="1.5rem" />
                    <Text>{item.text}</Text>
                  </div>
                </ButtonComponent>
              )),
          )}
          {allowViewFileOptions && (
            <SelectDropDown
              select={handleOptionsViewClick}
              cssClass="e-caret-hide"
              bgColor="transparent"
              items={fileViewOptions}
            >
              <IconComponent name={fileViewIconsMapper[filesViewMode]} width="1.25rem" height="1.25rem" />
            </SelectDropDown>
          )}
        </div>
      </div>
    </div>
  );
};

export default Toolbar;
